export const sectionColumnBreakpoints = {
  FIRST_BREAKPOINT: 4,
  SECOND_BREAKPOINT: 8,
} as const
